import type { ApiError } from '../services/api'

export function isApiError(e: unknown): e is ApiError {
  return typeof e === 'object' && e !== null && 'code' in e && 'status' in e
}

export function apiErrorMessage(e: unknown, fallback = 'Something went wrong'): string {
  if (!isApiError(e)) return fallback
  if (e.code === 'request_timeout') {
    return `${fallback} — ใช้เวลานานเกินกำหนด งานอาจยังทำงานอยู่ กรุณารอสักครู่แล้วตรวจสอบอีกครั้ง`
  }
  if (e.code === 'validation_error') {
    const errors = (e.details as { errors?: Array<{ loc?: unknown[]; msg?: string }> } | undefined)
      ?.errors
    const parts = (errors ?? [])
      .slice(0, 3)
      .map((row) => {
        const field = (row.loc ?? []).filter((part) => part !== 'body').join('.')
        return field && row.msg ? `${field}: ${row.msg}` : row.msg || ''
      })
      .filter(Boolean)
    if (parts.length) return `ข้อมูลไม่ผ่านการตรวจสอบ — ${parts.join(' · ')}`
  }
  return e.message
}
